
import * as actionType from "../../../context/actions";
import GetQuotationDataLocal from "./GetQuotationDataLocal";
import GetProformaInvoiceDataLocal from "./GetQuotationDataLocal";

const DeleteQuotationDataInLocal = async (state, dispatch, uniqueID) => {

    try {

        // Retrieve existing invoices from localStorage
        let existingData = JSON.parse(localStorage.getItem("LOCAL_QUOTATION")) || [];

        // Find the index of the invoice with the matching invoiceId
        const indexToDelete = existingData.findIndex((invoice, index) => invoice.uniqueID === uniqueID || index === uniqueID || invoice.id === uniqueID);

        // Validate if the invoice exists
        if (indexToDelete === -1) {
            return { success: true, message: "quotation deleted successfully!" };
        }

        // Remove the invoice at the found index
        existingData.splice(indexToDelete, 1);

        // Save updated data back to localStorage
        localStorage.setItem("LOCAL_QUOTATION", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Refresh invoice data
        await GetQuotationDataLocal(state, dispatch);

        return { success: true, message: "quotation deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};

export default DeleteQuotationDataInLocal;
